import GetStudentTypeMixin from '@/mixins/student-type';
import { VRuntimeShell } from '@grupoa/components';

export default {
  props: {
    html: {
      type    : String,
      default : '<p></p>'
    },
    grade: {
      type    : [String, Number],
      default : 0
    }
  },
  name       : 'TaskFeedback',
  mixins     : [GetStudentTypeMixin],
  components : {
    VRuntimeShell
  }
};
